import { UserEditHistoryDto } from '../models/notes.models';

/**
 * Build the display name for a "last updated by" byline from the edit-history
 * record the notes APIs return.
 *
 * Every field on UserEditHistoryDto is optional, so each part is dropped when
 * absent and an entry carrying neither name yields undefined rather than an
 * empty string — callers use that to decide whether to render the byline at
 * all. Centralized because the same join had been written out separately
 * wherever a note byline is shown, and a divergence there shows up as one
 * screen naming someone the next one does not.
 */
export function formatUserEditHistoryName(
  updatedBy?: UserEditHistoryDto | null,
): string | undefined {
  return (
    [updatedBy?.firstName, updatedBy?.lastName].filter(Boolean).join(' ') ||
    undefined
  );
}
